/* eslint-disable no-undef */

const create = function(vueObj) {
  const cube = vueObj.$refs.togglePlay;
  let timer = null;

  const handlerClick = () => {
    const video = vueObj.$refs.videoPlayer;
    if (video.paused) {
      vueObj.stateVideo = "Pause";
      video.play();
    } else {
      vueObj.stateVideo = "Play";
      video.pause();
    }
    timer = null;
  };

  const handlerMouseEnter = () => {
    cube.setAttribute("opacity", "1");

    if (!timer) {
      timer = setTimeout(() => {
        handlerClick();
      }, 1500);
    }
  };

  const handlerMouseLeave = () => {
    cube.setAttribute("opacity", "0.2");

    clearTimeout(timer);
    timer = null;
  };

  AFRAME.registerComponent("startbutton", {
    init() {
      cube.addEventListener("click", handlerClick);
      cube.addEventListener("mouseenter", handlerMouseEnter);
      cube.addEventListener("mouseleave", handlerMouseLeave);
    },
    remove() {
      cube.removeEventListener("click", handlerClick);
      cube.removeEventListener("mouseenter", handlerMouseEnter);
      cube.removeEventListener("mouseleave", handlerMouseLeave);
    }
  });
};

export default create;
